import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CircularProgress, Box, Alert, Typography, Container, Paper } from "@mui/material";
import axios from "axios";
import { useDispatch } from "react-redux";
import authSlice from "../auth/auth.slice";

function AdminLogin() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setError("Invalid login link");
        setTimeout(() => navigate("/login"), 3000);
        return;
      }

      try {
        const response = await axios.post("/api/user/verify-one-time-login", { token });
        
        // Check for the result in the response
        if (response.data.result) {
          // Set user in Redux store
          dispatch(authSlice.actions.setUser(response.data.result));
          
          // Navigate to projects page (or admin page if user is admin)
          setTimeout(() => {
            if (response.data.result.isAdmin) {
              navigate("/admin");
            } else {
              navigate("/projects");
            }
          }, 500);
        } else {
          throw new Error("No user data received");
        }
      } catch (error: any) {
        console.error("Failed to verify login token:", error);
        const errorMessage = error.response?.data?.error?.message || 
                           "Invalid or expired login link. Please request a new one.";
        setError(errorMessage);
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    verifyToken();
  }, [token, navigate, dispatch]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 3,
            textAlign: "center",
            width: "100%",
          }}
        >
          {error ? (
            <>
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
              <Typography variant="body2" color="text.secondary">
                Redirecting to login page...
              </Typography>
            </>
          ) : (
            <>
              <CircularProgress sx={{ mb: 2 }} />
              <Typography variant="h6" gutterBottom>
                Verifying login link...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Please wait while we authenticate your access
              </Typography>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
}

export default AdminLogin;